export const PRIMARY_GREEN = '#4caf50';
export const SECONDARY_GRAY = '#b7b7b7';
export const WHITE = '#fff';
